import React from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import Divider from 'material-ui/Divider';

import DoneIcon from 'material-ui/svg-icons/action/done';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';
import LockIcon from 'material-ui/svg-icons/action/lock-outline';
import * as colors from 'material-ui/styles/colors';

import Paper from 'material-ui/Paper';

import FormText from '../../../components/FormText'
import FormSelect from '../../../components/FormSelect'
import FormPaidHolidayContents from '../../../components/FormPaidHolidayContents'
import FormUserPriceContents from '../../../components/FormUserPriceContents'
import styles from "../../../styles";
import {typography} from "material-ui/styles/index";
import FormCheckBox from "../../../components/FormCheckBox";


const userMasterStyles = {
  paper: {
    padding: "20px 20px 40px 20px",
    marginTop: 10,
  },
  paperScroll: {
    padding: "20px 20px 20px 20px",
    marginTop: 10,
    marginBottom: 10,
    maxHeight: 394, overflow: 'auto'
  },
  paperTitle: {
    fontSize: 19,
    color: colors.grey700,
    fontWeight: typography.fontWeightLight,
    marginBottom: 15
  },
  paperSubTitle: {
    fontSize: 13,
    color: colors.grey500,
    fontWeight: typography.fontWeightLight,
    marginBottom: 15
  },
}

class UserMasterForm extends React.Component {


  render() {

    const {
      branchOfficeData,
      departmentData,
      priceData,
      selectedBranchOfficeId,
      error,
      reset,
      handleSubmit,
      initialValues,
      onFormRegistClick,
      onFormSearchClick,
      onFormResetClick,
      onLocalStorageSave
    } = this.props

    return (

      <form onSubmit={handleSubmit(() => {
      })}>

        {error && <div><span style={{color: 'rgb(244, 67, 54)'}}>{error}</span></div>}

        <div className="row">

          <div className="col-6">

            <Paper style={userMasterStyles.paper}>
              <h4 style={userMasterStyles.paperTitle}>基本情報</h4>
              <Divider />

              <div className="row">

                <div className="col-6">

                  <Field
                    name="branchOfficeId"
                    component={FormSelect}
                    style={{width: '100%'}}
                    label="支店名"
                  >
                    {
                      branchOfficeData && branchOfficeData.map((x, index) => {
                        return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                      })
                    }
                  </Field>

                </div>

                <div className="col-6">

                  <Field
                    name="departmentId"
                    component={FormSelect}
                    style={{width: '100%'}}
                    label="部署名"
                  >

                    <MenuItem value={''} primaryText=""/>
                    {!departmentData ? '' :
                      selectedBranchOfficeId ?
                        departmentData.map((x, index) => {
                          if (selectedBranchOfficeId == x.branchOfficeId) {
                            return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                          }
                        }) :
                        <MenuItem primaryText="支店を選択"/>
                    }

                  </Field>

                </div>

              </div>

              <div className="row">
                <div className="col-6">

                  <Field
                    name="name"
                    component={FormText}
                    label="社員名"
                    style={{width: '100%'}}
                    value={initialValues.name}
                  />

                </div>
                <div className="col-6">

                  <Field
                    name="xronosUserId"
                    component={FormText}
                    label="外部サイトID"
                    style={{width: '100%'}}
                    value={initialValues.xronosUserId}
                  />

                  </div> 
                </div>

              <div className="row">
                <div className="col-6">

                  <Field
                    name="email"
                    component={FormText}
                    label="ユーザID"
                    style={{width: '100%'}}
                    value={initialValues.email}
                  />

                </div>
                <div className="col-6">

                  <Field
                    name="password"
                    component={FormText}
                    label="パスワード"
                    style={{width: '100%'}}
                    value={initialValues.password}
                    //type="password"
                  />

                </div>
              </div>


              <div className="row">

                <div className="col-6">

                  <Field
                    name="permission"
                    component={FormSelect}
                    style={{width: '100%'}}
                    label="システム権限"
                  >
                    <MenuItem value={1} primaryText="一般ユーザ"/>
                    <MenuItem value={3} primaryText="TL"/>
                    <MenuItem value={2} primaryText="システム管理者"/>
                  </Field>

                </div>

                <div className="col-2" style={{
                  display: 'flex', alignItems: 'center'}}>
                  <div>
                    <Field label="退職" name="disable" component={FormCheckBox}
                           style={{ ...styles.checkRemember.style, fontSize: 13, width: '130px'}}
                           labelStyle={styles.checkRemember.labelStyle}
                           iconStyle={styles.checkRemember.iconStyle}
                    />
                  </div>
                </div>

              </div>


            </Paper>


            <div className="row" style={{marginTop: 10}}>
              <div className="col">
                <Paper style={userMasterStyles.paperScroll}>
                  <h4 style={userMasterStyles.paperTitle}>時間単価</h4>
                  <FieldArray name="userPriceList" component={FormUserPriceContents} priceData={priceData}/>
                </Paper>

              </div>
            </div>

          </div>


          <div className="col-6">

              <div className="row">
                <div className="col">
                  <Paper style={userMasterStyles.paperScroll}>
                    <h4 style={userMasterStyles.paperTitle}>有給休暇情報</h4>
                    {initialValues.paidHolidayResult &&
                    (
                        <h5 style={userMasterStyles.paperSubTitle}>(前年残日：{initialValues.paidHolidayResult.prevCountRemain}    当年残日：{initialValues.paidHolidayResult.currentCountRemain})</h5>
                    )
                    }
                    <Divider />
                    <FieldArray name="paidHolidayList" component={FormPaidHolidayContents}/>
                  </Paper>

                </div>
              </div>
          </div>


        </div>

        <div className="row" style={{marginTop: 20}}>

          <div className="col-6" style={{paddingTop: 5, display: 'flex', justifyContent: 'flex-start'}}>

            <FlatButton
              label="登録"
              labelPosition="before"
              primary={true}
              labelStyle={{color: colors.white, lineHeight: '40px'}}
              style={{height: '40px', width: '100px', marginRight: '20px'}}
              backgroundColor={colors.cyan700}
              hoverColor={colors.cyan900}
              icon={<DoneIcon color={colors.white}/>}
              onClick={handleSubmit(onFormRegistClick)}
            />

            {initialValues.id &&

            <FlatButton
              label="編集モード終了"
              primary={true}
              labelStyle={{color: colors.grey500, lineHeight: '40px'}}
              style={{height: '40px', width: '140px', marginRight: '20px'}}
              onClick={onFormResetClick}
            />
            }

          </div>

          <div className="col-6" style={{textAlign: 'right'}}>

            <FlatButton
              label="クリア"
              primary={true}
              labelStyle={{color: colors.grey500, lineHeight: '40px'}}
              style={{height: '40px', width: '100px', marginRight: '20px'}}
              // onClick={() => {
              //   reset()
              // }}
              onClick={() => {
                reset()
                onFormResetClick()
              }}
            />

            <FlatButton
              label="固定"
              labelPosition="before"
              primary={true}
              labelStyle={{color: colors.white, lineHeight: '40px'}}
              style={{height: '40px', width: '100px', marginRight: '20px'}}
              backgroundColor={colors.grey600}
              hoverColor={colors.grey700}
              icon={<LockIcon color={colors.white}/>}
              onClick={handleSubmit(onLocalStorageSave)}
            />

            <FlatButton
              label="検索"
              labelPosition="before"
              primary={true}
              labelStyle={{color: colors.white, lineHeight: '40px'}}
              style={{height: '40px', width: '100px'}}
              backgroundColor={colors.blue500}
              hoverColor={colors.blue700}
              icon={<SearchIcon color={colors.white}/>}
              onClick={handleSubmit(onFormSearchClick)}
            />

          </div>
        </div>


      </form>

    )

  }

}

UserMasterForm = reduxForm({
  form: 'userMasterForm',
  enableReinitialize: true,
})(UserMasterForm)

export default UserMasterForm




// WEBPACK FOOTER //
// ./src/containers/master/user/UserMasterForm.js